import { Color } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { DocumentSearchMatch } from 'dashboard/views/DashboardDocumentViewerView/DocumentViewerSearch';

interface SearchHighlightsProps {
  searchMatches: DocumentSearchMatch[];
  focusedIndex: number;
}

interface HighlightProps {
  fillHighlight: boolean;
  top: number;
  left: number;
  bottom: number;
  right: number;
}

const Highlight = styled('div')<HighlightProps>`
  position: absolute;
  top: ${({ top }) => `${top * 100}%`};
  left: ${({ left }) => `${left * 100}%`};
  height: ${({ top, bottom }) => `${(bottom - top) * 100}%`};
  width: ${({ right, left }) => `${(right - left) * 100}%`};
  background: ${({ fillHighlight }) => fillHighlight && Color.CoreBlue300};
  outline: 2px solid;
  outline-color: ${Color.CoreBlue600};
  border-radius: 4px;
  mix-blend-mode: darken;
`;

export const getElementIdForSearchHighlight = (id: number) => `document-search-highlight-${id}`;

const SearchHighlights = ({ searchMatches, focusedIndex }: SearchHighlightsProps) => {
  return (
    <>
      {searchMatches.map((match) => {
        const boundingBox = match.boundingBox;
        const uniqueId = getElementIdForSearchHighlight(match.id);
        return (
          <Highlight
            key={uniqueId}
            id={uniqueId}
            fillHighlight={focusedIndex === match.id}
            {...boundingBox}
          />
        );
      })}
    </>
  );
};

export default SearchHighlights;
